import React from 'react';
import { login } from 'account-portal-library/lib/facebookSignIn';
import AppVars from '../../../../AppVars.js';
import Loader from '../../../Loader';
import pushAnalytics from '../../../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance();

class FacebookButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleFacebookLogin = this.handleFacebookLogin.bind(this);
        this.state = { ...props }
    }

    async handleFacebookLogin() {
        window._dL = { ...(window._dL || {}), user_login_source: "Facebook" };

        pushAnalytics('aa-link', {
            ctaText: 'Continue with Facebook',
            link_text: 'Continue With Facebook',
            link_type: 'button',
            link_trigger: 'aa-link',
            content_section: 'Sign in Landing Page',
            metrics: 'km-sign-in-start',
            user_login_source: 'Facebook',
            user_entry_source: "Toyota",
        }, { component_name: "FacebookButton", component_version: "1.0.0" });

        await login(
            sessionStorage.AP_STYLE,
            appVars.getBaseUrl(),
            appVars.getRealm(),
            appVars.getFacebookSignInTree(),
            appVars.getDomain(),
            appVars.getName()
        )
    }

    render() {
        if (this.props.implicitRegister) {
            pushAnalytics("aa-component-view", { component_name: "FacebookButton", component_version: "1.0.0" });
            this.handleFacebookLogin();
            return (
                <Loader />
            )
        } else {
            return (
                <button alt="Continue With Facebook" onClick={this.handleFacebookLogin} className="button-box-facebook">
                    <span className="button-text button-text-facebook">Continue with Facebook</span>
                </button>
                // <img alt = "Continue with Facebook" onClick={this.handleFacebookLogin} src={FacebookButtonImg} className="button-social button-facebook"/>
            )
        }
    }
}

export default FacebookButton;